import { Helmet } from "react-helmet-async";

interface AnalyticsProps {
  measurementId: string; // Your GA4 measurement ID
}

export default function Analytics({ measurementId }: AnalyticsProps) {
  // Only include analytics in production
  if (process.env.NODE_ENV !== "production") {
    return null;
  }

  // Check if we're in a WebContainer environment
  const isWebContainer =
    typeof window !== "undefined" &&
    window.location.hostname.includes("webcontainer");

  // Don't load analytics in WebContainer preview
  if (isWebContainer) {
    return null;
  }

  return (
    <Helmet>
      <script
        async
        src={`https://www.googletagmanager.com/gtag/js?id=${measurementId}`}
      ></script>
      <script>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){
            try {
              dataLayer.push(arguments);
            } catch (e) {
              console.warn('Analytics error:', e);
            }
          }
          gtag('js', new Date());
          gtag('config', '${measurementId}', {
            send_page_view: false // Disable automatic page views
          });

          // Custom error handler for analytics
          window.addEventListener('error', function(e) {
            if (e.message.includes('google-analytics') || e.message.includes('gtag')) {
              console.warn('Analytics error:', e.message);
              e.preventDefault(); // Prevent the error from bubbling up
            }
          });

          // Send pageview on route change
          let lastPage = window.location.pathname;
          const sendPageview = () => {
            const page = window.location.pathname;
            if (page !== lastPage) {
              gtag('event', 'page_view', {
                page_path: page,
                send_to: '${measurementId}'
              });
              lastPage = page;
            }
          };

          // Watch for route changes
          if (typeof window !== 'undefined') {
            window.addEventListener('popstate', sendPageview);
            const pushState = history.pushState;
            history.pushState = function() {
              pushState.apply(history, arguments);
              sendPageview();
            };
          }
        `}
      </script>
    </Helmet>
  );
}
